<template><div><h1 id="eb-guthaben-abstimmung" tabindex="-1"><a class="header-anchor" href="#eb-guthaben-abstimmung"><span>EB-Guthaben-Abstimmung</span></a></h1>
<p>EB-Guthaben-Abstimmung — Diese Auswertung dient der Abstimmung der kreditorischen Debitoren zwischen funtrade und der Finanzbuchhaltung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Auswertung dient der Abstimmung der kreditorischen Debitoren zwischen funtrade und der Finanzbuchhaltung. Die Auswertung berücksichtigt alle Bewegungen auf dem Guthabenkonto und zeigt die Summe der Buchungen mit Typ G, GS. Buchungstypen-Paare (z.B. G, GS oder A, AS) werden getrennt ausgewiesen. Dies ermöglicht die Bereinigung von Falschbuchungen auf dem Guthabenkonto.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Guthaben-Abstimmung</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Journalnummer:</dt>
<dd>Eingrenzung nach Journalnummer, ? = offen</dd>
<dt>bis:</dt>
<dd>Eingrenzung nach Journalnummer, ? = offen</dd>
<dt>von Datum:</dt>
<dd>Eingrenzung nach Datum der letzten Bewegung, ? = offen</dd>
<dt>bis:</dt>
<dd>Eingrenzung nach Datum der letzten Bewegung, ? = offen</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>Bildschirm:</dt>
<dd>ja</dd>
<dt>Drucker:</dt>
<dd>A4 hoch</dd>
<dt>Druckdatei:</dt>
<dd>ja</dd>
<dt>Textdatei:</dt>
<dd>ja</dd>
</dl>
<h2 id="output-liste-rekapitulation-der-parameter" tabindex="-1"><a class="header-anchor" href="#output-liste-rekapitulation-der-parameter"><span>Output (Liste) Rekapitulation der Parameter</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>AdrNr.:</td>
<td>Personen-ID der Adresse mit Guthaben</td>
</tr>
<tr>
<td>Guth.diff.:</td>
<td>Veränderung des Guthabens innerhalb der definierten Grenzen. Die Grenzen werden eingegeben in den Parametern über [Journalnummer von - bis] und [Datum von - bis]. Ist die untere Grenze nicht definiert, entspricht dieser Wert dem Total der Guthaben zu einem bestimmten Stichdatum ([Journalnummer von] UND [Datum von] zeigen &quot;?&quot;)</td>
</tr>
<tr>
<td>Total Guth.:</td>
<td>Total der Guthaben zu einem bestimmten Stichdatum. Stichdatum ist das [bis Datum] aus den Parametern oder das [bis Datum] aus dem Journal, welches im Parameter [bis Journalnummer] angegeben wurde. Massgeblich ist das jüngste Datum</td>
</tr>
<tr>
<td>Name:</td>
<td>ame, Vorname aus der Adresse</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>Summe der Spalten [Guth.diff.] und [Total Guth.]</td>
<td>Summe der Spalten [Guth.diff.] und [Total Guth.]</td>
</tr>
<tr>
<td>Anzahl ausgewiesene Guthaben</td>
<td>Anzahl ausgewiesene Guthaben</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel &quot;Stichdatum&quot;</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line"> Datenausgabe                                01.03.2000 17:24:58 leh  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                             EB-Guthaben-Abstimmung</span>
<span class="line"></span>
<span class="line">   von Journalnummer: ?          bis: |</span>
<span class="line">   von Datum........:            bis: 31.12.1998</span>
<span class="line"></span>
<span class="line">   Diese Liste zeigt eine Zusammenfassung der Bewegungen auf dem</span>
<span class="line">   Guthabenkonto .</span>
<span class="line">   Berücksichtigt werden alle Buchungen mit Buchungstyp G, GS. Existieren</span>
<span class="line">   weitere Buchungen mit abweichenden Buchungstypen, werden diese</span>
<span class="line">   am Schluss - nach der Summe der Buchungen G, GS - ausgewiesen.</span>
<span class="line">   Die Spalte "Guth.diff." (Guthabendifferenz) zeigt die Summe der Buchungen,</span>
<span class="line">   die durch Journalnummer und Datum eingegrenzt wurde.</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                          EB-Guthabenliste</span>
<span class="line">     AdrNr.    Guth.diff.   Total Guth. Name</span>
<span class="line"> ---------- ------------- ------------- --------------------</span>
<span class="line">    161,917         71.90         71.90 Schmid Birri Josef</span>
<span class="line">    302,933         29.90         29.90 Collège de la Poste</span>
<span class="line">    305,302         28.90         28.90 Primarschulhaus</span>
<span class="line"> .</span>
<span class="line"> .</span>
<span class="line"> 99,912,188        452.80        452.80 Librairie de l'Ale S</span>
<span class="line"> 99,912,638        230.00        230.00 Peck &amp; Hale Holding</span>
<span class="line"> 99,912,869        350.70        350.70 Huggler Ingenieure A</span>
<span class="line"> ------------- ------------- --------------------</span>
<span class="line">                46,562.20     46,562.20                      TOTAL</span>
<span class="line">                                                         466 COUNT</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel &quot;Zeitraum&quot;</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"> Datenausgabe                                02.03.2000 11:04:42 leh  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                             EB-Guthaben-Abstimmung</span>
<span class="line"></span>
<span class="line">   von Journalnummer: ?          bis: |</span>
<span class="line">   von Datum........: 01.12.1998 bis: 31.12.1998</span>
<span class="line"></span>
<span class="line">   Diese Liste zeigt eine Zusammenfassung der Bewegungen auf dem</span>
<span class="line">   Guthabenkonto.</span>
<span class="line">   Berücksichtigt werden alle Buchungen mit Buchungstyp G, GS. Existieren</span>
<span class="line">   weitere Buchungen mit abweichenden Buchungstypen, werden diese</span>
<span class="line">   am Schluss - nach der Summe der Buchungen G, GS - ausgewiesen.</span>
<span class="line">   Die Spalte "Guth.diff." (Guthabendifferenz) zeigt die Summe der Buchungen,</span>
<span class="line">   die durch Journalnummer und Datum eingegrenzt wurde.</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                          EB-Guthabenliste</span>
<span class="line">     AdrNr.    Guth.diff.   Total Guth. Name</span>
<span class="line"> ---------- ------------- ------------- --------------------</span>
<span class="line">    161,917          0.00         71.90 Schmid Birri Josef</span>
<span class="line">    302,933          0.00         29.90 Collège de la Poste</span>
<span class="line"> .</span>
<span class="line"> .</span>
<span class="line"> 99,912,188        452.80        452.80 Librairie de l'Ale S</span>
<span class="line"> 99,912,638          0.00        230.00 Peck &amp; Hale Holding</span>
<span class="line"> 99,912,869          0.00        350.70 Huggler Ingenieure A</span>
<span class="line">            ------------- ------------- --------------------</span>
<span class="line">                 8,751.55     46,562.20                      TOTAL</span>
<span class="line">                                                         492 COUNT</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


